import { getApiCaller, postApiCaller, deleteApiCaller } from "../apiCaller";

export const getAllNotifications = async ({
  currentPage = 1,
  limit = 10,
} = {}) => {
  const response = await getApiCaller(
    `notification/get?page=${currentPage}&limit=${limit}`
  );
  return response;
};

export const postNotification = async (payload = {}) => {
  const response = await postApiCaller("notification/send", payload);
  return response;
};

export const deleteNotification = async (id) => {
  const response = await deleteApiCaller(`notification/delete/${id}`);
  return response;
};
